import { Answer } from "Models";
import includes from "ramda/es/includes";
import values from "ramda/es/values";
import head from "ramda/es/head";
import both from "ramda/es/both";
import equals from "ramda/es/equals";
import pipe from "ramda/es/pipe";
import complement from "ramda/es/complement";
import isEmpty from "ramda/es/isEmpty";

import { calcSimplePoints } from "../_common/pointsCalculationHelper";

export const calculatePoints = (answer) => {
  const answers = answer.userInput();
  const expectedAnswers = answer.correctAnswers(); // = [{ "?":["x", "y"] }, ...]
  const question = answer.question();
  const isCountPerAnswer = question.countPerAnswer();

  if (!answers || answers.length < 1) return 0;
  const findTargetList = (key) => head(values(expectedAnswers[key - 1]));

  /**
   * standard click-matrixes are evaluation that only
   * when the whole line is correct, the user get 1 point
   */
  if (answer.lineEvaluation()) {
    const isTaskCorrect = (a) =>
      a.value.every((v) => includes(v.toString(), findTargetList(a.key)));

    const hasTaskCorrectLength = (a) =>
      a.value.length === findTargetList(a.key).length;

    const results = answers.map(both(isTaskCorrect, hasTaskCorrectLength));

    console.log("results", results);

    const countCorrectOnes = () => results.filter(equals(true)).length;
    const points = () => Number(question.points());

    console.log("results", results);
    console.log("isCountPerAnswer", isCountPerAnswer);

    return !isCountPerAnswer
      ? calcSimplePoints(answer)
      : countCorrectOnes() * points();
  } else {
  /**
   * specials click-matrixes are evaluation that every correct answer
   * will give a point
   */
    let correctCtr = 0;
    let wrongCtr = 0;

    /**
     * for all given answers of the users
     * we check if it's correct or wrong
     */
    answers.forEach((a) => {
      const expected = findTargetList(a.key);
      a.value.forEach((v) => {
        const correct = includes(v.toString(), expected);
        correctCtr += correct ? 1 : 0;
        wrongCtr += correct ? 0 : 1;
      });
    });

    console.log("correctCtr", correctCtr);
    console.log("wrongCtr", wrongCtr);


    /**
     * this is the number of correct answers
     * the user should have given when
     * everything's correct
     *
     * expectedAnswers contains object
     * for every line one key - value -pair
     * linenumber: [ correctColumnNo1,  correctColumnNo2, ...]
     * 
     * we count the number of correct ColumnsNo as maxCorrect
     */
    const maxCorrect = expectedAnswers
      .filter(pipe(values, head, complement(isEmpty)))
      .reduce((sum, a) => sum + Object.values(a).reduce((sum2, a2) => a2.length, 0)
      , 0);

    const missing = maxCorrect - (correctCtr - wrongCtr);

    const result = question.realQuestionsCount() - missing;

    return result > 0 ? result : 0;
  }
};
